module.exports = __webpack_public_path__ + "img/OFFLINE.2004ace8.svg";